import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

export function NewPOASuccess() {
  const navigate = useNavigate();
  
  useScrollToTop();
  
  const handleHome = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleCreateAnother = useCallback(() => {
    navigate('/people/self/life-documents/power-of-attorney/new');
  }, [ navigate ]);
  
  return (
    <div className="new-poa-success screen-container">
      <ScreenHeader
        title="Congratulations!"
        description="You have successfully completed your Power of Attorney document"
      />
      
      <div className="success-content">
        <div className="success-icon">
          <span className="material-icons">check_circle</span>
        </div>

        <h2>Your Power of Attorney is Complete</h2>
        
        <div className="success-message">
          <p>
            You have successfully created a comprehensive Power of Attorney document that will 
            protect your financial interests and provide peace of mind for you and your family.
          </p>
        </div>

        <div className="next-steps">
          <h3>Next Steps</h3>
          <ul>
            <li>Print and sign your Power of Attorney document</li>
            <li>Have it notarized according to your state's requirements</li>
            <li>Provide copies to your agents and trusted family members</li>
            <li>Store the original in a safe place</li>
            <li>Consider creating other important estate planning documents</li>
          </ul>
        </div>

        <div className="important-reminders">
          <h3>Important Reminders</h3>
          <ul>
            <li>Review your Power of Attorney periodically and update as needed</li>
            <li>Inform your agents about their responsibilities</li>
            <li>Keep your document in a safe but accessible location</li>
            <li>Consider creating a healthcare directive as well</li>
          </ul>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleHome}
        handleSecondary={handleCreateAnother}
        primaryText="Go to Home"
        secondaryText="Create Another Document"
      />
    </div>
  );
}
